import React, { PureComponent } from "react";
import { connect } from "react-redux";
import Viewport from "../Viewport";
import PDFDialog from "../PDFDialog";
import Calculations from "../Calculations";
import SubmitDialog from "../submitDialog";
import FloatingTool from "../FloatingTool";
import FloatingToolPipes from "../FloatingToolPipes";
import LoadingScreen from "react-loading-screen";
import DebugingTool from "../DebugingTool";
import ContainerDimensions from "react-container-dimensions";
import { Accordion, AccordionItem } from "react-sanfona";
import BlockUi from "react-block-ui";
import {
  injectTestingAction,
  enableDebuging
} from "../../actions/layout-actions";
import { switchProductType } from "../../actions/product-type.actions";
import TopCalculations from "../LayoutSections/TopCalculations/topCalculations.container";
import TopBarComponent from "../LayoutSections/TopBar/top-bar.component";
import ProjectInfo from "../LeftMenu/ProjectInfo/project-info.component";
import BackgroundAndToolsContainer from '../LeftMenu/BackgroundImage/backgroundAndTools.container';
import DrawingsAndReports from '../LeftMenu/DrawingsAndReports/drawingsAndReports.component';

import Components from '../LeftMenu/Component/components.component';

import './index.css';
import ReportModal from '../ReportModal';
import TogglePanelIcon from '../LayoutSections/TogglePanelIcon/togglePanelIcon.component';
import { PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import ProjectsCrudModal from '../ProjectsCrudModal';
import ProjectsAdminCrudModal from '../ProjectsAdminCrudModal';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Toolbox from '../Toolbox';
import AgreementDialog from '../AgreementDialog/AgreementDialog';
import DisableLayer from '../LayoutSections/DisableLayer/disable-layer.container';
import ModalAlert from '../ModalAlert/modal-alert.container';
import Contact from '../LeftMenu/Contact';
import PipePdfReportModal from '../PipesPDF/pipePdfReportModal.component';
import { GLOBAL_PROJECT_TYPE_PIPE, GLOBAL_PROJECT_TYPE_CHAMBER } from '../../lib/types';
import ManifoldEntry from '../ManifoldEntry';
import {
  showManifoldChamberEditOrRemove,
  removeManifold,
  showManifoldEntryDialog,
} from '../../actions/manifold-entry-actions';
import { Dialog, DialogFooter, DialogType } from 'office-ui-fabric-react';
import { DefaultButton } from 'office-ui-fabric-react/lib-commonjs';
import ManifoldSelectors from '../../reducers/main-manifold-reducer';
import { deactivate, cleanChambersByArrayIsolator } from '../../actions/chamber-actions';
import ProjectSelectors from '../../reducers/project-reducer';
import { setMultiBedDesktopEnabled } from '../../actions/multi-bed-actions';
import FloatingToolInsertaTee from '../FloatingToolInseraTee';
import FloatingToolInspectionPort from '../FloatingToolInspectionPort';
import { openAccordionSection, closeAccordionSection } from '../../actions/accordion-actions';
import ToggleTutorialDialog from '../Tutorial/tutorialStartDialog';

import SignupModal from "../SignUp/signup.component";

const cultecLogoBg = require('../../media/big-cultec-waves-watermark-50.png');
const loadingLogoURI = require('../../media/cultec_logov2-2.png');


class Layout extends PureComponent {
  state = {
    flag: false,
    layoutHeight: 0,
    needsUpdate: false,
    accordionsHeight: 0,
    contentDisabled: false,
    combinationBarHeight: 0,
    errorDialogHidden: true,
    loadingScreenShowing: true,
    hasError: false,
    includeImperviousLinerWaringError: false,
    accordionSections: [
      { id: 0, name: 'tutorialProjectInformation' },
      { id: 1, name: 'tutorialBackgroundAndTools' },
      { id: 2, name: 'tutorialSystemParameters' },
      { id: 3, name: 'tutorialDrawingsAndReports' },
      { id: 4, name: 'tutorialContactUs' },
    ],
  };

  async componentDidMount() {
    setTimeout(() => {
      this.setState({
        loadingScreenShowing: false,
      });
    }, 1000);
    const urlParams = new URLSearchParams(window.location.search);

    if (urlParams.has('d')) {
      this.props.enableDebuging();
    }

    switch (urlParams.get('projectType')) {
      case GLOBAL_PROJECT_TYPE_PIPE:
        window._projectType = GLOBAL_PROJECT_TYPE_PIPE;
        break;
      case GLOBAL_PROJECT_TYPE_CHAMBER:
      default:
        window._projectType = GLOBAL_PROJECT_TYPE_CHAMBER;
    }

    if (process.env.NODE_ENV !== 'development') {
      document.addEventListener('contextmenu', (event) => event.preventDefault());
    }

    if (process.env.REACT_APP_IS_TESTING === 'TRUE') {
      document.addEventListener(
        'INJECT_TESTING_ACTION',
        (e) => {
          /* injecting custom action */
          this.props.injectTestingAction(e.detail);
        },
        false,
      );
    }

    if (urlParams.has('isFromDesktop')) {
      this.props.setMultiBedDesktopEnabled(true, urlParams.get('isMultiBed') === '1');
    }

    this._updateDimensions = this.updateDimensions.bind(this);
    this._updateDimensions();
    window.addEventListener('resize', this._updateDimensions);

    let pType = localStorage.getItem('productType');

    if (!pType) {
      localStorage.setItem('productType', GLOBAL_PROJECT_TYPE_CHAMBER);
    } else if (pType !== GLOBAL_PROJECT_TYPE_CHAMBER && pType !== GLOBAL_PROJECT_TYPE_PIPE) {
      localStorage.setItem('productType', GLOBAL_PROJECT_TYPE_CHAMBER);
    } else {
      this.props.switchProductType(pType);
    }

    await this.checkLatestVersion();
  }

  async checkLatestVersion() {
    try {
      let response = await fetch('version.json', {
        headers: {
          'Cache-Control': 'no-cache',
        },
      });
      let data = await response.json();

      if (data.version !== process.env.REACT_APP_MINICAD_VERSION) {
        this.setState({
          needsUpdate: true,
        });
      } else {
        console.log('Current remote version is:', data.version);
      }
    } catch (e) {
      if (e.message.includes('Unexpected token <'))
        console.info(`At Layout/index.js :: checkLatestVersion(); No version file found in remote. ${e.message}`);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this._updateDimensions);
  }

  updateDimensions() {
    try {
      const topBar = document.getElementById('top-bar');
      const layoutHeight = document.body.clientHeight - topBar.clientHeight;

      this.setState({
        layoutHeight,
      });

      setTimeout(() => {
        const toolboxBar = document.getElementById('toolbox-bar');
        const accordionsHeight = layoutHeight - toolboxBar.clientHeight;

        this.setState({
          accordionsHeight,
        });
      });
    } catch (exception) {
      console.warn('An issue occurred while retrieving layout dimensions');
    }
  }

  renderPDFReportModal = () => {
    if (this.props.showPdfModal) {
      return <ReportModal />;
    } else {
      return null;
    }
  };

  renderEditOrRemoveManifoldChamberModal = () => {
    const { content, lang, showManifoldChamberEditOrRemovePrompt } = this.props;

    return (
      <Dialog
        hidden={!showManifoldChamberEditOrRemovePrompt}
        dialogContentProps={{
          type: DialogType.normal,
          title: content[lang].editOrRemoveManifold,
          subText: content[lang].editOrRemoveManifoldSubText,
        }}
        minWidth={'400px'}
        modalProps={{
          isBlocking: true,
        }}>
        <DialogFooter>
          <PrimaryButton
            onClick={() => this.handleRemovalPromptDialogClose(false)}
            text={content[lang].editOrRemoveManifoldEditButton}
            className="edit-new-manifold"
          />
          <DefaultButton
            onClick={() => this.handleRemovalPromptDialogClose(true)}
            text={content[lang].editOrRemoveManifoldRemoveButton}
            className="edit-existing-manifold"
          />
        </DialogFooter>
      </Dialog>
    );
  };

  handleRemovalPromptDialogClose = (remove) => {
    const { manifoldId, accessory, row, col } = this.props.manifoldChamberEditOrRemoveData;
    if (remove) {
      // ImperviousLiner validations
      if (
        ManifoldSelectors.countOutlets() === 1 &&
        this.props.manifoldChamberEditOrRemoveData.accessory.id === 'Outlet-Manifold' &&
        this.props.hasImperviousLiner
      ) {
        this.setState({ includeImperviousLinerWaringError: true });
        this.props.showManifoldChamberEditOrRemove(false);
        return null;
      }
      //Remove manifold
      const manifoldToRemove = ManifoldSelectors.getManifoldByIdFromMain(manifoldId);
      if (manifoldToRemove) {
        this.props.removeManifold(manifoldToRemove);
        this.props.cleanChambersByArrayIsolator(manifoldId, row, col);
      }
      this.props.deactivate(row, col);
    } else {
      this.props.showManifoldEntryDialog(manifoldId, accessory, false);
    }
    this.props.showManifoldChamberEditOrRemove(false);
  };

  disableDblClick = () => {
    document.getElementById('tutorialSystemParameters').style.pointerEvents = 'none';
    setTimeout(() => {
      document.getElementById('tutorialSystemParameters').style.pointerEvents = 'auto';
    }, 350);
  };

  render() {
    const { lang, content, projectType, isSigningIn, isSigningOut } = this.props;

    const { layoutHeight, accordionsHeight } = this.state;

    const renderAccordion = (title, component, disabled, toggle, tutorialClass, skip, tutorialSelector) => {
      if (skip) return;
      const overFlowFlag = this.props.toggleTutorial ? 'visible' : 'hidden';
      const isSectionOpen = this.props.accordionStates[tutorialClass];
      return (
        <AccordionItem
          key={0}
          title={
            <div className="titleStyles">
              <span className={'ms-Icon ms-Icon--ChevronRightSmall'} />
              <i className={'ms-Icon ms-Icon--ChevronDownSmall'} /> &nbsp; {title}
            </div>
          }
          expanded={isSectionOpen}
          id={tutorialClass}
          className={`${tutorialSelector} ${tutorialClass} accordion-section ${disabled ? ' disabled' : ''}`}
          onClick={() => this.disableDblClick()}
          style={{ overflow: overFlowFlag }}
          disabled={this.props.toggleTutorial}>
          <DisableLayer name={tutorialClass}>{component}</DisableLayer>
        </AccordionItem>
      );
    };

    const renderAccordionBlock = () => {
      const handleAccordionChange = (data) => {
        const activeItemsArray = data && Array.isArray(data.activeItems) ? data.activeItems : [];

        this.state.accordionSections.forEach((section) => {
          // Check if the section is active
          const isActive = activeItemsArray.includes(section.id);

          // Compare with the current state and dispatch actions as needed
          if (isActive && !this.props.accordionStates[section.name]) {
            this.props.openAccordionSection(section.name);
          } else if (!isActive && this.props.accordionStates[section.name]) {
            this.props.closeAccordionSection(section.name);
          }
        });
      };

      return (
        <div className="scrollableSection" style={{ height: `${accordionsHeight}px` }}>
          <Accordion onChange={handleAccordionChange} duration="300">
            {renderAccordion(
              content[lang].projectInfo,
              <ProjectInfo />,
              false,
              true,
              'tutorialProjectInformation',
              null,
              'projectInfoSection',
            )}

            {renderAccordion(
              content[lang].backgroundAndTools,
              <BackgroundAndToolsContainer />,
              false,
              false,
              'tutorialBackgroundAndTools',
              null,
              'backgroundAndToolsSection',
            )}

            {/* HIDDEN FOR CULTEC
            {( this.props.multiBedIsFromDesktop && !this.props.multiBedIsMultiBedDesktopEnabled )
              ? null
              : renderAccordion(
                content[lang].multiBedManagement,
                <MultiBedManagementComponent />,
                false,
                false,
                "tutorialMultiBed")
            }*/}
            {renderAccordion(
              content[lang].systemParameters,
              <Calculations />,
              false,
              false,
              'tutorialSystemParameters',
              null,
              'systemParametersSection',
            )}

            {renderAccordion(
              content[lang].components,
              <Components />,
              false,
              false,
              'tutorialComponents',
              projectType === GLOBAL_PROJECT_TYPE_PIPE,
            )}

            {/* HIDDEN FOR CULTEC
            {renderAccordion(
              content[lang].advancedSettings,
              <AdvancedSettings />,
              false,
              false,
              "tutorialAdvancedSettings"
            )}
            */}
            {renderAccordion(
              content[lang].drawingsAndReports,
              <DrawingsAndReports />,
              false,
              false,
              'tutorialDrawingsAndReports',
              null,
              'drawingsAndReportsSection',
            )}
            {renderAccordion(
              content[lang].contactUs,
              <Contact />,
              false,
              false,
              'tutorialContactUs',
              null,
              'contactUsSection',
            )}
          </Accordion>
          <div style={{ marginTop: '5px' }} />
        </div>
      );
    };

    const renderDisableLayerBlock = () => {
      return (
        <div style={css.viewPort}>
          <DebugingTool />
          <FloatingTool />
          <FloatingToolPipes />
          <FloatingToolInsertaTee />
          <FloatingToolInspectionPort />
          <ManifoldEntry />
          {this.state.flag ? (
            <TogglePanelIcon side="Right" margin="0" togglePanel={() => this.setState({ flag: !this.state.flag })} />
          ) : (
            <TogglePanelIcon side="Left" margin="0" togglePanel={() => this.setState({ flag: !this.state.flag })} />
          )}
          <DisableLayer attr={css.viewPort2} name="canvasLayer">
            <ContainerDimensions>
              <Viewport />
            </ContainerDimensions>
          </DisableLayer>

          <TopCalculations />
        </div>
      );
    };

    return (
      <React.Fragment>
        <BlockUi tag="div" className="loadingBlockUI" blocking={isSigningIn || isSigningOut}>
          <div className="updateDiv" style={{ display: this.state.needsUpdate ? 'block' : 'none' }}>
            {content[lang].youAreUsingOutdatedVersion} &nbsp;
            <PrimaryButton
              onClick={(evt) => {
                window.location.reload(true);
              }}
              text={content[lang].updateNow}
            />{' '}
            <br />
            <strong>{content[lang].note}</strong> {content[lang].updateNowMultipleClicks}
          </div>
          <div className="ms-Grid" style={{ height: '100%' }}>
            <LoadingScreen
              className="loadingScreen"
              loading={this.state.loadingScreenShowing || this.props.loadingBed}
              bgColor={
                this.props.loadingBed && !this.props.loadingMultiBedProject ? 'rgba(217,217,214,0.75)' : '#D9D9D6'
              }
              spinnerColor="#0C92CD"
              textColor="#0C92CD"
              logoSrc={loadingLogoURI}>
              <div
                className="loadingDiv"
                style={{
                  visibility: !this.props.chamberType && this.state.errorDialogHidden ? 'visible' : 'hidden',
                }}
              />
            </LoadingScreen>
            <div id="top-bar" className="ms-Grid-row">
              <TopBarComponent />
            </div>
            {layoutHeight ? (
              <div id="layout" className="ms-Grid-row" style={{ height: `${layoutHeight}px` }}>
                <div
                  className={
                    this.state.flag === false
                      ? 'ms-Grid-col ms-sm8 ms-md8 ms-lg4 ms-xl3 ms-xxl3 ms-xxxl2 leftSection'
                      : null
                  }
                  style={
                    this.state.flag === false ? { textAlign: 'left', backgroundColor: '#F5FAFC' } : { display: 'none' }
                  }>
                  <div id="toolbox-bar">
                    <Toolbox />
                  </div>
                  {accordionsHeight ? renderAccordionBlock() : null}
                </div>
                {document.body.clientWidth >= 768 ? renderDisableLayerBlock() : null}
              </div>
            ) : null}
            <PDFDialog />
            <PipePdfReportModal />
            <SubmitDialog />
            <ProjectsCrudModal />
            <ProjectsAdminCrudModal />
            {this.renderPDFReportModal()}
            <AgreementDialog />
            <ToastContainer />
            <ModalAlert />

            {this.renderEditOrRemoveManifoldChamberModal()}
          </div>
          <Dialog
            hidden={!this.state.includeImperviousLinerWaringError}
            dialogContentProps={{
              type: DialogType.normal,
              title: content[lang].imperviousLinerWarningTitle,
              subText: content[lang].imperviousLinerWarning2,
            }}
            modalProps={{
              isBlocking: false,
              containerClassName: 'alert-level-container alert-level-3-container',
            }}>
            <DialogFooter>
              <DefaultButton
                onClick={() => {
                  this.setState({ includeImperviousLinerWaringError: false });
                }}
                text={content[lang].cancel}
                className={'outline_grey_ads'}
              />
            </DialogFooter>
          </Dialog>
          <ToggleTutorialDialog />
          <SignupModal />
          <div className="watermarked-image-container">
            <img className="watermarked-image" src={process.env.PUBLIC_URL + cultecLogoBg} />
          </div>
        </BlockUi>
      </React.Fragment>
    );
  }
}

const css = {
  viewPort: {
    height: '100%',
    display: 'flex',
    minWidth: '10px',
    minHeight: '10px',
    position: 'relative',
    // flexDirection: 'column',
  },
  viewPort2: {
    height: '100%',
    minWidth: '100%',
    minHeight: '100%',
  },
};

const mapStateToProps = (state) => {
  return {
    showPdfModal: state.pdf.showPdfModal,
    chamberType: state.globals.chamberType,
    showPipesPdfModal: state.pdf.showPipesPdfModal,
    showManifoldChamberEditOrRemovePrompt: state.manifoldEntry.showManifoldChamberEditOrRemovePrompt,
    manifoldChamberEditOrRemoveData: state.manifoldEntry.manifoldChamberEditOrRemoveData,

    isSigningIn: state.authentication.isSigningIn,
    isSigningOut: state.authentication.isSigningOut,

    projectType: state.globals.projectType,

    pipeVolumevolume: state.pipeBed.volume,
    content: state.localization.content,
    lang: state.localization.lang,
    isMultiBedProject: ProjectSelectors.isMultiBedProject(),

    loadingBed: state.multiBed.loadingBed,
    loadingMultiBedProject: state.multiBed.loadingMultiBedProject,
    multiBedIsFromDesktop: state.multiBed.isFromDesktop,
    multiBedIsMultiBedDesktopEnabled: state.multiBed.isMultiBedDesktopEnabled,
    hasImperviousLiner: state.calculations.hasImperviousLiner,
    accordionStates: state.accordion.accordionStates,
    toggleTutorial: state.tutorial.toggleTutorial,
    expandAccordion: state.accordion.expandAccordion,
  };
};

const mapDispatchToProps = {
  enableDebuging,
  switchProductType,
  injectTestingAction,
  showManifoldEntryDialog,
  showManifoldChamberEditOrRemove,
  removeManifold,
  deactivate,
  cleanChambersByArrayIsolator,
  setMultiBedDesktopEnabled,
  openAccordionSection,
  closeAccordionSection,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Layout);



// WEBPACK FOOTER //
// ./src/components/Layout/index.js